import { MouseEvent } from 'react';

import PetitionCommentCard from '../../components/petition-comment/petition-comment';
import { PetitionComment } from '../../../../types/petition-comment.type';

import styles from './comments-list.module.scss';

type Props = {
    comments: PetitionComment[];
    onSelectAuthor: (id: number) => void;
};

const CommentsList = ({ comments, onSelectAuthor }: Props) => {
    const handleAuthorSelect = (ev: MouseEvent) => {
        const target = (ev.target as HTMLElement).dataset;
        if (!target['id']) return;
        onSelectAuthor(Number(target['id']));
    };

    if (!comments.length) {
        return <span>No hay comentarios.</span>;
    }

    return (
        <ul className={styles.commentList} onClick={handleAuthorSelect}>
            {comments.map((comment, idx) => (
                <PetitionCommentCard comment={comment} key={idx} />
            ))}
        </ul>
    );
};

export default CommentsList;
